export default __webpack_public_path__ + "static/hiv-testing_outside-mobile-a8c6e30644f3f9867543471397ded328.jpg";